import React, { useEffect } from 'react';
import Home from './Home';
import About from './About';
import Benefits from './Benefits';
import MLPService from './MLPService';
import Portfolio from 'sections/Portfolio';
import TeamCreation from './TeamCreation';
import StartupRecruiting from './StartupRecruiting';
import scrollToComponent from 'react-scroll-to-component';
import TopBar from 'sections/TopBar';
import Footer from 'sections/Footer';
import * as styledComponents from './styles';
import DetectMobile from 'helpers/DetectMobile.js';

import {
  useLocation
} from "react-router-dom";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const Landing = () => {
  useEffect(()=>{
    (async ()=> {
      const reply = await gtag('config', "G-S3JNHMJ2KX", {'page_title' : 'Landing', 'page_path': window.location.pathname});
      console.log(reply);
    })();
  }, []);

  let offsetTop = -65;
  if(DetectMobile()){
    offsetTop = 0;
  }

  let homeRef = React.createRef();
  let howToRef = React.createRef();
  let aboutRef = React.createRef();
  let portfolioRef = React.createRef();
  let mlpServiceRef = React.createRef();
  let teamCreationRef = React.createRef();
  let recruitingRef = React.createRef();
  let footerRef = React.createRef();
  let query = useQuery().get('section');
  let queryType = useQuery().get('type');

  useEffect(() => {
      if (queryType !== 'scrolled') {
          switch (query) {
              case 'home':
                  scrollToComponent(homeRef.current, { align: 'top', offset: offsetTop });
                  break;
              case 'howto':
                  scrollToComponent(howToRef.current, { align: 'top', offset: offsetTop });
                  break;
              case 'about':
                  scrollToComponent(aboutRef.current, { align: 'top', offset: offsetTop });
                  break;
              case 'portfolio':
                  scrollToComponent(portfolioRef.current, { align: 'top', offset: offsetTop });
                  break;
              case 'mlp':
                  scrollToComponent(mlpServiceRef.current, { align: 'top', offset: offsetTop });
                  break;
              case 'teamassembly':
                  scrollToComponent(teamCreationRef.current, { align: 'top', offset: offsetTop });
                  break;
              case 'startuphr':
                  scrollToComponent(recruitingRef.current, { align: 'top', offset: offsetTop });
                  break;
              case 'contact':
                  scrollToComponent(footerRef.current, { align: 'top', offset: offsetTop });
                  break;
              default:
                  scrollToComponent(homeRef.current, { align: 'top', offset: offsetTop });
                  break;
          }
      }
  }, [query, queryType]);

  const scrollToTop = () => {
      scrollToComponent(topRef.current, { align: 'top', offset: offsetTop });
  }

  return (
    <styledComponents.LandingContainer>
      <TopBar />
      <Home ref={homeRef} />
      <Benefits ref={howToRef}/>
      <About ref={aboutRef}/>
      <Portfolio ref={portfolioRef}/>
      <MLPService ref={mlpServiceRef}/>
      <TeamCreation ref={teamCreationRef}/>
      <StartupRecruiting ref={recruitingRef}/>
      <Footer ref={footerRef}/>
    </styledComponents.LandingContainer>
  );
}

export default Landing;
